'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  root: {
    position: 'relative'
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '8px'
  },
  myContainer: {
    flexDirection: 'row-reverse'
  }
};
module.exports = exports.default;